import React, { useEffect } from 'react'
import { AlertFilled, AlertOutlined, BookOutlined, CloseOutlined, HomeFilled, ShopFilled, ShopOutlined } from '@ant-design/icons';

import "./SideBar.css"
import { useNavigate } from 'react-router-dom';
import { Monitor } from '../Models/Monitor';
import { addMonitor } from '../Api/Monitor';

interface Props{
    open:Boolean
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
    
}

const SideBar = ({open, setOpen}:Props) => {
    const navigate = useNavigate();
    
  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Función de limpieza para remover la clase si el componente se desmonta
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [open]); // El efecto se ejecuta cada vez que isSidebarOpen cambia

      const sendMonitor = async (seccion:string)=>{
          try
          {let user:string= localStorage.getItem("user") || ""

          let monitor:Monitor={
              action:`Cambio de seccion ${seccion}`,
              user:user
          }
          await addMonitor(monitor)}
          catch(error){}
      }

  return (

    <>
    <div className='SideBar-Component' style={{right:open ? "40vw" : "110vw"}}>


        <div className='SideBar-Header'>


            <div className='Sidebar-Header-logo'>
                <img src='/logo-small.png'  />
            </div>

            <div className='SideBar-Header-close'>
                <CloseOutlined onClick={()=>{setOpen(false)}} style={{cursor:"pointer", color:"#FFF"}}  />
            </div>

        </div>

        <div className='SideBar-Items'>
 

            <div className='SideBar-item' onClick={() =>{sendMonitor("/productos"); navigate("/productos") ; setOpen(false)}}>
                <ShopOutlined />
                <span>Productos</span>
            </div>

            <div className='SideBar-item' onClick={() =>{sendMonitor("/proximamente");navigate("/proximamente") ; setOpen(false)}}>
                <AlertOutlined />
                <span>Proximamente</span>
            </div>

            <div className='SideBar-item' onClick={() =>{sendMonitor("/cartas");navigate("/cartas"); setOpen(false)}}>
            <BookOutlined />
            <span>Cartas</span>
            </div>
        </div>


    </div>
    <div className='SideBar-Background' onClick={()=>{setOpen(false)}} style={{display:open ? "flex" : "none"}}>

    </div>
  
    </>
  
  )
}

export default SideBar